import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {HttpErrorResponse} from "@angular/common/http";
import {FIREBASE_CONFIG} from "./app/firebase-config.token";

if (environment.production) {
  enableProdMode();
}

fetch('/assets/config/firebase-config.json')
  .catch((err) => {
    console.error("Failed to load dynamic firebase configuration file!", err);
    return null;
  })
  .then(response =>
  {
    if (!response || response instanceof HttpErrorResponse) {
      return null;
    }
    return response.json();
  })
  .then(config => {
    if (!config) {
      return;
    }
    environment.firebaseConfig = config;
  }).finally(() => {
  platformBrowserDynamic([
    { provide: FIREBASE_CONFIG, useValue: environment.firebaseConfig }
  ]).bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

